export default function CartContent() {
  return <section id="cart-content" className="bg-background py-space-xl">
      <div className="container mx-auto px-space-md max-w-7xl">
        <div className="bg-white rounded-lg shadow-soft p-space-lg border border-border">
          [woocommerce_cart]
        </div>
      </div>
    </section>;
}